// PNG proof at the printer's 305 dpi, and a print-to-PDF proof via the browser print dialog.
import { S } from './state.js';
import { h, toast } from './dom.js';
import { labelSvgString } from './canvas.js';
import { ensureBwip } from './bwip.js';

export const PRINTER_DPI = 305;
const pxFor = (units) => Math.round((units / 2540) * PRINTER_DPI);
const baseName = () => (S.filename || 'label').replace(/\.(itf|image)$/i, '');

async function prepareSvg(widthPx, heightPx) {
  if (S.fields.some((f) => f.kind === 'barcode')) {
    try {
      await ensureBwip();
    } catch (err) {
      toast(err.message, 'warn');
    }
  }
  return labelSvgString({ width: widthPx, height: heightPx });
}

export async function exportPNG() {
  if (!S.label) return;
  const W = pxFor(S.label.width);
  const H = pxFor(S.label.height);
  try {
    const svg = await prepareSvg(W, H);
    const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }));
    const img = new Image();
    await new Promise((res, rej) => {
      img.onload = res;
      img.onerror = () => rej(new Error('the SVG could not be rasterised'));
      img.src = url;
    });
    const canvas = h('canvas', { width: W, height: H });
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, W, H);
    ctx.drawImage(img, 0, 0, W, H);
    URL.revokeObjectURL(url);
    const blob = await new Promise((res) => canvas.toBlob(res, 'image/png'));
    const dl = URL.createObjectURL(blob);
    const a = h('a', { href: dl, download: `${baseName()}_${PRINTER_DPI}dpi.png`, style: { display: 'none' } });
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(dl), 2000);
    toast(`Exported ${W} × ${H} px proof at ${PRINTER_DPI} dpi`, 'good');
  } catch (err) {
    console.error(err);
    toast(`PNG export failed: ${err.message}`, 'bad');
  }
}

export async function printProof() {
  if (!S.label) return;
  const wmm = S.label.width / 100;
  const hmm = S.label.height / 100;
  const svg = await prepareSvg(pxFor(S.label.width), pxFor(S.label.height));
  const frame = h('iframe', { title: 'Print proof', style: { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' } });
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  doc.open();
  doc.write(
    `<!doctype html><title>${baseName()} proof</title><style>@page{size:${wmm}mm ${hmm}mm;margin:0}html,body{margin:0;background:#fff}svg{display:block;width:${wmm}mm;height:${hmm}mm}</style>${svg}`,
  );
  doc.close();
  setTimeout(() => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } catch (err) {
      toast(`Print failed: ${err.message}`, 'bad');
    }
    setTimeout(() => frame.remove(), 60000);
  }, 150);
}
